import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const BrutalistProtocol = () => {
  const containerRef = useRef(null);
  const stepsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const steps = stepsRef.current;
      
      steps.forEach((step, i) => {
        // Sticky stacking effect
        ScrollTrigger.create({
          trigger: step,
          start: 'top top',
          end: 'bottom top',
          pin: true, 
          pinSpacing: false,
          scrub: true,
        });

        // Animate previous step when current step overlaps
        if (i > 0) {
          gsap.from(step, {
            yPercent: 100,
            ease: 'none',
            scrollTrigger: {
              trigger: step,
              start: 'top bottom',
              end: 'top top',
              scrub: true
            }
          });
          
          // Scale down previous step
          gsap.to(steps[i-1], {
            scale: 0.9,
            opacity: 0.5,
            filter: 'blur(10px)',
            scrollTrigger: {
              trigger: step,
              start: 'top bottom',
              end: 'top top',
              scrub: true
            }
          });
        }
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  const addToRefs = (el) => {
    if (el && !stepsRef.current.includes(el)) {
      stepsRef.current.push(el);
    }
  };

  return (
    <section ref={containerRef} className="bg-background text-foreground relative z-10">
      
      {/* Step 1 */}
      <div ref={addToRefs} className="h-screen w-full flex items-center justify-center relative bg-background border-b border-border z-10 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none">
           <div className="w-[300px] h-[300px] sm:w-[600px] sm:h-[600px] border border-current rounded-full animate-[spin_10s_linear_infinite]" />
           <div className="w-[200px] h-[200px] sm:w-[400px] sm:h-[400px] border border-current rounded-full animate-[spin_15s_linear_infinite_reverse]" />
        </div>
        <div className="step-content max-w-4xl px-6 text-center z-10 w-full">
          <div className="text-accent font-mono text-sm mb-4">[01] ИНИЦИАЛИЗАЦИЯ</div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl font-sans font-bold uppercase mb-6 break-words">Вы выбираете<br/>размер и срок</h2>
          <p className="text-lg sm:text-xl font-mono text-muted-foreground max-w-2xl mx-auto">
            Интеллектуальная система подбора. Точность до сантиметра. Оплата только за используемое пространство.
          </p>
        </div>
      </div>

      {/* Step 2 */}
      <div ref={addToRefs} className="h-screen w-full flex items-center justify-center relative bg-background border-b border-border z-20 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none">
           <div className="flex items-center gap-1 h-32">
             {Array.from({ length: 20 }).map((_, i) => (
               <div key={i} className="w-2 sm:w-4 bg-current animate-pulse" style={{ height: `${Math.random() * 100}%`, animationDelay: `${i * 0.1}s` }} />
             ))}
           </div>
        </div>
        <div className="step-content max-w-4xl px-6 text-center z-10 w-full">
          <div className="text-accent font-mono text-sm mb-4">[02] ЗАЩИТА АКТИВНА</div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl font-sans font-bold uppercase mb-6 break-words">Ваши вещи<br/>под контролем</h2>
          <p className="text-lg sm:text-xl font-mono text-muted-foreground max-w-2xl mx-auto">
            Круглосуточный мониторинг. Датчики движения, температуры и влажности. Полная изоляция.
          </p>
        </div>
      </div>

      {/* Step 3 */}
      <div ref={addToRefs} className="h-screen w-full flex items-center justify-center relative bg-background border-b border-border z-30 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none w-full overflow-hidden">
           <div className="w-full h-1 bg-red-500 absolute top-1/2 left-0 animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite]" />
           <div className="absolute inset-0 grid grid-cols-[repeat(10,minmax(0,1fr))] sm:grid-cols-[repeat(20,minmax(0,1fr))] gap-4 opacity-20">
             {Array.from({ length: 400 }).map((_, i) => (
               <div key={i} className="border-r border-current h-full" />
             ))}
           </div>
        </div>
        <div className="step-content max-w-4xl px-6 text-center z-10 w-full">
          <div className="text-accent font-mono text-sm mb-4">[03] ДОСТУП РАЗРЕШЕН</div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl font-sans font-bold uppercase mb-6 break-words">Получаете<br/>цифровой доступ</h2>
          <p className="text-lg sm:text-xl font-mono text-muted-foreground max-w-2xl mx-auto">
            Доступ 24/7 по личному коду. Вход через смартфон. Никаких ключей, никаких встреч с менеджерами.
          </p>
        </div>
      </div>

    </section>
  );
};

export default BrutalistProtocol;
